import React, { useEffect, useRef, useState } from "react";
import {
  daysInGivenMonth,
  getDaysInFYMonths,
  minutesToHHMM,
  months,
  secondsToHHMM,
} from "../../../../Utilitie";
import { ahWiseTHead, remarkTableHeader } from "../AFHelper";
import DynamicTable from "../../../../Extra/DynamicTable";
import { RiResetLeftFill } from "react-icons/ri";
import { PiGreaterThan } from "react-icons/pi";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const MonthWise = ({ data, more }) => {
  const yearTR1 = useRef();
  const yearTR2 = useRef();
  const tableRef = [yearTR1, yearTR2];
  const tableAG = useRef();
  const tableSC = useRef();
  const [nearYear, setNearYear] = useState(more.years[more?.years?.length - 1]);
  const yearsData = data.filter((a) => a.F_YEAR === nearYear);
  const [subCause, setSubCause] = useState([
    ...new Set(yearsData.map((o) => o.SUB_CAUSE)),
  ]);
  let assetHead = [...new Set(yearsData.map((o) => o.ASSET_GROUP))];

  // let subCause = ;
  const refMonths = months;
  const [filters, setFilters] = useState({
    F_YEAR: nearYear,
    A_MONTH: null,
    ASSET_GROUP: null,
    SUB_CAUSE: null,
  });
  const [filteredData, setFilteredData] = useState([]);
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (value) {
          return item[key] === value;
        } else {
          return true;
        }
      });
    });
  }
  useEffect(() => {
    // if (Object.keys(filters).length > 0) {
    setFilteredData(filterData((data, filters)));
    // } else {
    //   setFilteredData(data);
    // }
  }, [filters, data]);
  useEffect(() => {
    if (filters.F_YEAR) {
      setNearYear(filters.F_YEAR);
    }
    if (filters.ASSET_GROUP) {
      setSubCause([
        ...new Set(
          yearsData
            .filter((o) => o.ASSET_GROUP === filters.ASSET_GROUP)
            .map((o) => o.SUB_CAUSE),
        ),
      ]);
    } else {
      setSubCause([...new Set(yearsData.map((o) => o.SUB_CAUSE))]);
    }
  }, [filters]);

  return (
    <div>
      Month Wise
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">Year Wise Asset Failure</h4>
        </div>
        <div className="row">
          {more &&
            more?.years?.map((year, j) => {
              let temp = data.filter((a) => a.F_YEAR === year);
              let tempMonths = [...new Set(temp.map((t) => t["A_MONTH"]))];
              let months = tempMonths.sort(
                (a, b) =>
                  refMonths.indexOf(a?.toUpperCase()) -
                  refMonths.indexOf(b?.toUpperCase()),
              );
              let days = temp ? getDaysInFYMonths(year, months) : 1;
              let assetHead = [...new Set(temp.map((o) => o.ASSET_GROUP))];
              let subCauses = [...new Set(temp.map((o) => o.SUB_CAUSE))];

              return (
                <div key={j} className="col-md-6">
                  <div className=" ">
                    <div className=" ">
                      <h4 className="text-white bg-dark"> {year}</h4>
                    </div>
                    <div className="table-responsive newUiBody">
                      <table
                        className="table newUiTable table-striped table-hover"
                        ref={tableRef[j]}
                      >
                        <thead className="table-dark">
                          <tr>
                            {ahWiseTHead.map((head, i) => {
                              return <th key={i}>{head}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {months.map((m, q) => {
                            let fData = temp.filter((t) => t.A_MONTH === m);
                            return (
                              <tr
                                className={
                                  m === filters.A_MONTH &&
                                  year === filters.F_YEAR &&
                                  `border border-primary table-primary`
                                }
                                key={10 * q}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    F_YEAR: year,
                                    A_MONTH: m,
                                  })
                                }
                              >
                                <td>{m}</td>
                                <td>{fData.length}</td>
                                <td>
                                  {(
                                    fData.length /
                                    daysInGivenMonth(months.indexOf(m), year)
                                  ).toFixed(2)}
                                </td>
                                <td>
                                  {minutesToHHMM(
                                    fData.reduce((sum, t) => {
                                      return (
                                        sum +
                                        t.Average_Detention_Time_Mins_Total_20
                                      );
                                    }, 0) /
                                      daysInGivenMonth(months.indexOf(m), year),
                                  )}
                                </td>{" "}
                                <td>
                                  {fData.reduce((sum, o) => {
                                    return (
                                      sum +
                                      Number(o.No_of_Trains_DelayedTotal_17)
                                    );
                                  }, 0)}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    fData.reduce((sum, t) => {
                                      return (
                                        sum +
                                        t.Average_Detention_Time_Mins_Total_20 *
                                          60
                                      );
                                    }, 0),
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      <DownloadExcel
                        tableRef={tableRef[j]}
                        fileName={`AF month Wise -${year}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <div className="row">
          <div className="  bg-dark text-white  me-2 ms-2">
            <h4>cause wise</h4>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="  bg-dark text-white mt-1  pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Asset Group - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          key === "ASSET_GROUP" ||
                            key === "SUB_CAUSE" ||
                            !value || (
                              <h6 key={i}>
                                <PiGreaterThan />
                                {value}
                              </h6>
                            )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        setFilters({
                          F_YEAR: nearYear,
                          A_MONTH: null,
                          ASSET_GROUP: null,
                          SUB_CAUSE: null,
                        })
                      }
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive newUiBody">
                <table
                  className="table newUiTable table-striped table-hover"
                  ref={tableAG}
                >
                  <thead className="table-dark">
                    <tr>
                      <th>Sr</th>
                      {ahWiseTHead.map((head, i) => {
                        return <th key={i}>{head}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {assetHead.map((ah, q) => {
                      let fData = yearsData.filter((t) =>
                        filters?.A_MONTH
                          ? t.ASSET_GROUP === ah &&
                            t.A_MONTH === filters.A_MONTH
                          : t.ASSET_GROUP === ah,
                      );
                      let tempMonths = [
                        ...new Set(fData.map((t) => t["A_MONTH"])),
                      ];
                      // console.log(fData);
                      let months = tempMonths.sort(
                        (a, b) =>
                          refMonths.indexOf(a?.toUpperCase()) -
                          refMonths.indexOf(b?.toUpperCase()),
                      );
                      let days = fData
                        ? getDaysInFYMonths(nearYear, months)
                        : 1;

                      return (
                        <tr
                          className={
                            ah === filters.ASSET_GROUP &&
                            `border border-primary table-primary`
                          }
                          key={10 * q}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setFilters({
                              ...filters,
                              F_YEAR: nearYear,
                              ASSET_GROUP: ah,
                              SUB_CAUSE: null,
                            })
                          }
                        >
                          <td>{q + 1}</td>
                          <td>{ah}</td>
                          <td>{fData.length}</td>
                          <td>{(fData.length / days).toFixed(2)}</td>
                          <td>
                            {secondsToHHMM(
                              fData.reduce((sum, t) => {
                                return (
                                  sum +
                                  t.Average_Detention_Time_Mins_Total_20 * 60
                                );
                              }, 0) / days,
                            )}
                          </td>{" "}
                          <td>
                            {fData.reduce((sum, o) => {
                              return (
                                sum + Number(o.No_of_Trains_DelayedTotal_17)
                              );
                            }, 0)}
                          </td>
                          <td>
                            {secondsToHHMM(
                              fData.reduce((sum, t) => {
                                return (
                                  sum +
                                  t.Average_Detention_Time_Mins_Total_20 * 60
                                );
                              }, 0),
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <DownloadExcel
                  tableRef={tableAG}
                  fileName={`AF Asset Wise -${filters.F_YEAR} / ${
                    filters.A_MONTH ? filters.A_MONTH : "all "
                  } month 
                  }`}
                />
              </div>
            </div>
            {/* /////////////////////////
              Sub cause
            // //////// */}
            <div className="col-md-6">
              <div className="  bg-dark text-white mt-1  pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Sub cause - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          !value || key === "SUB_CAUSE" || (
                            <h6 key={i}>
                              <PiGreaterThan />
                              {value}
                            </h6>
                          )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        setFilters({
                          F_YEAR: filters.F_YEAR,
                          A_MONTH: filters.A_MONTH,
                          ASSET_GROUP: null,
                          SUB_CAUSE: null,
                        })
                      }
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive newUiBody  p-0 ">
                <div style={{ maxHeight: "350px", overflow: "auto" }}>
                  <table
                    className="table newUiTable table-striped table-hover mt-1 p-0"
                    ref={tableSC}
                  >
                    <thead className="table-dark sticky-top">
                      <tr>
                        <th>Sr</th>
                        {ahWiseTHead.map((head, i) => {
                          return <th key={i}>{head}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {subCause.map((cs, q) => {
                        let fData = filters?.A_MONTH
                          ? yearsData.filter(
                              (t) =>
                                t.SUB_CAUSE === cs &&
                                t.A_MONTH === filters.A_MONTH,
                            )
                          : filters?.A_MONTH && filters?.ASSET_GROUP
                            ? yearsData.filter(
                                (t) =>
                                  t.ASSET_GROUP === filters.ASSET_GROUP &&
                                  t.SUB_CAUSE === cs &&
                                  t.A_MONTH === filters.A_MONTH,
                              )
                            : yearsData.filter((t) => t.SUB_CAUSE === cs);

                        let tempMonths = [
                          ...new Set(fData.map((t) => t["A_MONTH"])),
                        ];

                        let days =
                          data && tempMonths.length > 1
                            ? getDaysInFYMonths(nearYear, tempMonths)
                            : 1;

                        return (
                          <tr
                            className={
                              cs === filters.SUB_CAUSE &&
                              `border border-primary table-primary`
                            }
                            key={10 * q}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setFilters({
                                ...filters,
                                F_YEAR: nearYear,
                                SUB_CAUSE: cs,
                              })
                            }
                          >
                            <td>{q + 1}</td>
                            <td>{cs}</td>
                            <td>{fData.length}</td>
                            <td>
                              {fData.length > 0
                                ? (fData.length / days).toFixed(2)
                                : 0}
                            </td>
                            <td>
                              {secondsToHHMM(
                                fData.reduce((sum, t) => {
                                  return (
                                    sum +
                                    t.Average_Detention_Time_Mins_Total_20 * 60
                                  );
                                }, 0) / days,
                              )}
                            </td>{" "}
                            <td>
                              {fData.reduce((sum, o) => {
                                return (
                                  sum + Number(o.No_of_Trains_DelayedTotal_17)
                                );
                              }, 0)}
                            </td>
                            <td>
                              {secondsToHHMM(
                                fData.reduce((sum, t) => {
                                  return (
                                    sum +
                                    t.Average_Detention_Time_Mins_Total_20 * 60
                                  );
                                }, 0),
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <DownloadExcel
                  tableRef={tableSC}
                  fileName={`AF Sub cause Wise-${filters.F_YEAR} / ${
                    filters.A_MONTH ? filters.A_MONTH : "all "
                  } month /  ${
                    filters.ASSET_GROUP ? filters.ASSET_GROUP : "all AG"
                  }`}
                />
              </div>
            </div>{" "}
          </div>
        </div>

        {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <div
          className="row
      "
        >
          {filteredData && (
            <div>
              <div className="  bg-dark text-white pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Failure Remarks for - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          !value || (
                            <h6 key={i}>
                              <PiGreaterThan />
                              {value}
                            </h6>
                          )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => setFilters({ F_YEAR: nearYear })}
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <DynamicTable
                data={filteredData}
                headers={remarkTableHeader}
                rowsPerPage={15}
                fontSize={"12px"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default MonthWise;
